module.exports = __webpack_public_path__ + "images/internal/datashake/the_knot.png";